import routes from '../../router/routes'
import { getMenuList, getTopMenuIndex, getAppDefaultMenu } from '../../utils/utils'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    currentMenu: getAppDefaultMenu(), // 默认顶级菜单
    topMenuKeys: [0], // 选中的顶级菜单
    subMenuList: [],
    collapsed: false,
    menuList: [],
    dataMap: null
  },
  getters: {
    dataMap: state => {
      return state.dataMap ? state.dataMap : Vue.ls.get('DATA_MAP')
    }
  },
  mutations: {
    SET_DATA_MAP: (state, map) => {
      state.dataMap = map
      Vue.ls.set('DATA_MAP', map)
    },
    TOGGLE_COLLAPSED: state => {
      state.collapsed = !state.collapsed
    },
    SET_MENU_LIST: (state, menuList) => {
      state.menuList = menuList
    },
    SET_SUB_MENUS: (state, menu) => {
      const { menuList } = state
      const subMenu = menuList.find(it => it.name === menu.name)
      const { children } = subMenu
      state.subMenuList = children
    },
    SET_TOP_MENU_KEY: (state, menu) => {
      const index = getTopMenuIndex(menu)
      state.topMenuKeys = [index]
    },
    SET_APP_BREADCRUMB: (state, menu) => {
      // console.log(menu)
    }
  },
  actions: {
    setMenusList: ({ state, commit }, backendMenuList) => {
      commit('SET_TOP_MENU_KEY', { name: state.currentMenu })
      commit('SET_MENU_LIST', getMenuList(routes, backendMenuList))
      commit('SET_SUB_MENUS', { name: state.currentMenu })
      commit('SET_APP_BREADCRUMB', { name: state.currentMenu })
    },
    async loadSystemMaps ({ commit }) {
      const response = await Vue.$http.app.getLanguage()
      const { data } = response
      commit('SET_DATA_MAP', data)
    }
  }
}
